import { memo } from 'react';
import { Handle } from 'reactflow';
import "./styles.css";

function RedSquareNode({ data }) {
  return (
    <div className="int__red-square-node"
      style={{
        backgroundColor: "#9a1413",
        padding: "14px"
      }}
    >
      <Handle
        type="target"
        position="top"
        id="input"
        style={{ width: 0, height: 0, top: -10, border: "none", backgroundColor: "#9a1413" }}
      />
      <div
        style={{
          marginTop: "-10px",
          marginLeft: "-90px"
        }}
      >
        <input
          className="nodrag"
          type="text"
          defaultValue={data.label}
          disabled
          style={{ textAlign: "center", width: 170, fontSize: 13 }}
        />
      </div>
      <Handle
        type="target"
        position="left"
        id="input_left"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, left: -75 }}
      />
      <Handle
        type="source"
        position="right"
        id="output_right"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, right: -65 }}
      />
      <Handle
        type="source"
        position="bottom"
        id="output"
        style={{ width: 0, height: 0, bottom: -10, border: "none", backgroundColor: "transparent" }}
      />
    </div>
  );
}

export default memo(RedSquareNode);